import { useTranslation } from 'react-i18next';

import { PanelSection } from './PanelSection';

// Placeholder — no activity-log resolver covering WhatsApp + case events exists yet.
export const ActivitySection = () => {
    const { t } = useTranslation();

    return (
        <PanelSection title={t('WHATSAPP_CHAT.USER_INFO.ACTIVITY.TITLE')}>
            <p className="py-1.5 text-sm text-grey">{t('WHATSAPP_CHAT.USER_INFO.ACTIVITY.COMING_SOON')}</p>
        </PanelSection>
    );
};
